import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import {  defaultSAL1010_R01DetailDto, defaultSAL1010_R01HeaderDto, SAL1010_R01DetailDto, SAL1010_R01HeaderDto } from './Dto_SAL1010_R01';
import { showWarning } from 'src/utils/toast/toastUtil';

export interface SAL1010_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	customCd: string;
	customNm: string;
	orderStatus: string;
}

export interface Store_SAL1010_R01 {
	SAL1010_R01Filter: SAL1010_R01Filter;
	SAL1010_R01PastFilter: SAL1010_R01Filter;
	setSAL1010_R01Filter: (filter: Partial<SAL1010_R01Filter>) => void;
	setSAL1010_R01PastFilter: (filter: Partial<SAL1010_R01Filter>) => void;

	// ====== 판매주문 리스트 및 선택/편집 ======
	SAL1010_R01List: SAL1010_R01HeaderDto[];
	setSAL1010_R01List: (salesOrderList: SAL1010_R01HeaderDto[]) => void;
	removeSAL1010_R01List: (index: number) => void;

	editSAL1010_R01: SAL1010_R01HeaderDto | null;
	setEditSAL1010_R01: (editSalesOrder: SAL1010_R01HeaderDto | null) => void;

	selectedSAL1010_R01: SAL1010_R01HeaderDto | undefined;
	setSelectedSAL1010_R01: (data: SAL1010_R01HeaderDto | undefined) => void;
	initSelectedSAL1010_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedSAL1010_R01DetailList: string[];
	setDeletedSAL1010_R01DetailList: (idList: string[]) => void;
	addDeletedSAL1010_R01DetailList: (idList: string[]) => void;
	removeDeletedSAL1010_R01DetailList: (idList?: string[]) => void;

	// ====== 판매주문 상세(디테일) 데이터 ======
	SAL1010_R01DetailList: SAL1010_R01DetailDto[];
	setSAL1010_R01DetailList: (data: SAL1010_R01DetailDto[]) => void;
	insertSAL1010_R01DetailList: (data: SAL1010_R01DetailDto[], index?: number) => void;
	removeSAL1010_R01DetailList: (index: number) => void;
	updateSAL1010_R01DetailList: (index: number, data: SAL1010_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedSAL1010_R01DetailList: string[];
	setSelectedSAL1010_R01DetailList: (idList: string[]) => void;
	addSelectedSAL1010_R01DetailList: (idList: string[]) => void;
	removeSelectedSAL1010_R01DetailList: (idList?: string[]) => void;
	initSelectedSAL1010_R01DetailList: () => void;

	originalSAL1010_R01DetailList: SAL1010_R01DetailDto[];
	setOriginalSAL1010_R01DetailList: (data: SAL1010_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;		setDetailFetchTrigger: (trigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	

	//출하여부, 출하정보 존재시 수주/발주/입고/출고 정보 수정 불가
	isTransported: boolean;
	setIsTransported: (isTransported: boolean) => void;

	// ====== 초기화 ======
	initData: () => void;
}

export const defaultSAL1010_R01Filter: SAL1010_R01Filter = {
	compCd: '',
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1), // 이번 달 1일
		to: new Date()  // 오늘
	},
	customCd: '',
	customNm: '',
	orderStatus: 'N',
};

export const useSAL1010_R01Store = create<Store_SAL1010_R01>((set) => ({
	SAL1010_R01Filter: defaultSAL1010_R01Filter,
	SAL1010_R01PastFilter: defaultSAL1010_R01Filter,
	setSAL1010_R01Filter: (filter: Partial<SAL1010_R01Filter>) => set((state) => ({
		...state,
		SAL1010_R01Filter: {
			...state.SAL1010_R01Filter,
			...filter
		}
	})),
	setSAL1010_R01PastFilter: (filter: Partial<SAL1010_R01Filter>) => set((state) => ({
		...state,
		SAL1010_R01PastFilter: {
			...state.SAL1010_R01PastFilter,
			...filter
		}
	})),

	// ====== 판매주문 리스트 및 선택/편집 ======
	SAL1010_R01List: [],
	setSAL1010_R01List: (salesOrderList: SAL1010_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			SAL1010_R01List: salesOrderList
		}
	}),
	removeSAL1010_R01List: (index: number) => set((state) => {
		const newSAL1010_R01List = [...state.SAL1010_R01List];
		newSAL1010_R01List.splice(index, 1);
		return {
			...state,
			SAL1010_R01List: newSAL1010_R01List
		}
	}),

	editSAL1010_R01: defaultSAL1010_R01HeaderDto,
	setEditSAL1010_R01: (editSalesOrder: SAL1010_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editSAL1010_R01: editSalesOrder
		}
	}),

	selectedSAL1010_R01: undefined,
	// 판매주문 행 선택 시 editSalesOrder도 동기화
	setSelectedSAL1010_R01: (data: SAL1010_R01HeaderDto | undefined) => set((state) => {
		return { 
			selectedSAL1010_R01: data, 
			selectedSAL1010_R01DetailList: [], deletedSAL1010_R01DetailList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
		};
	}),
	initSelectedSAL1010_R01: () => set({ selectedSAL1010_R01: undefined, editSAL1010_R01: defaultSAL1010_R01HeaderDto, SAL1010_R01DetailList: [], detailFetchTrigger: false }),

	detailFetchTrigger: false,
	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	// ====== 판매주문 상세(디테일) 데이터 ======
	SAL1010_R01DetailList: [],
	setSAL1010_R01DetailList: (data: SAL1010_R01DetailDto[]) => set((state) => {
		let newList: SAL1010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultSAL1010_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			SAL1010_R01DetailList: newList
		}
	}),
	insertSAL1010_R01DetailList: (data: SAL1010_R01DetailDto[], index?: number) => set((state) => {
		let newSAL1010_R01DetailList = [...state.SAL1010_R01DetailList];

		let targetRowData = newSAL1010_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newSAL1010_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newSAL1010_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newSAL1010_R01DetailList = newSAL1010_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newSAL1010_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultSAL1010_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newSAL1010_R01DetailList.splice(index, 0, ...newData);
		} else {
			newSAL1010_R01DetailList.push(...newData);
		}

		return {
			...state,
			SAL1010_R01DetailList: newSAL1010_R01DetailList
		}
	}),
	removeSAL1010_R01DetailList: (index: number) => set((state) => {
		const newSAL1010_R01DetailList = [...state.SAL1010_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			SAL1010_R01DetailList: newSAL1010_R01DetailList
		}
	}),
	updateSAL1010_R01DetailList: (valueIndex: number, data: SAL1010_R01DetailDto) => set((state) => {
		const _SAL1010_R01DetailList = state.SAL1010_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.orderQty < 0) {
			showWarning('수량은 0보다 작을 수 없습니다.');
			data.orderQty = 0;
			data.itemAmt = 0;
		}
		if(data.orderPrice < 0) {
			showWarning('단가는 0보다 작을 수 없습니다.');
			data.orderPrice = 0;
			data.itemAmt = 0;
		}
		if(data.dcAmt < 0) {
			showWarning('할인액은 0보다 작을 수 없습니다.');
			data.dcAmt = 0;
			data.itemAmt = 0;
		}
		return {
			...state,
			SAL1010_R01DetailList: _SAL1010_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedSAL1010_R01DetailList: [],
	setDeletedSAL1010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedSAL1010_R01DetailList: idList
		}
	}),
	addDeletedSAL1010_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedSAL1010_R01DetailList];

		for(const valueIndex of idList) {
			_deletedDetailList.push(valueIndex);
		}
		
		return {
			...state,
			deletedSAL1010_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedSAL1010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedSAL1010_R01DetailList: [...state.deletedSAL1010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedSAL1010_R01DetailList: [],
	setSelectedSAL1010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedSAL1010_R01DetailList: idList
		}
	}),
	addSelectedSAL1010_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedSAL1010_R01DetailList = [...state.selectedSAL1010_R01DetailList];
		if(idList.length > 0) {
			_selectedSAL1010_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedSAL1010_R01DetailList: _selectedSAL1010_R01DetailList
		}
	}),
	removeSelectedSAL1010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedSAL1010_R01DetailList: [...state.selectedSAL1010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedSAL1010_R01DetailList: () => set({ selectedSAL1010_R01DetailList: [] }),

	originalSAL1010_R01DetailList: [],
	setOriginalSAL1010_R01DetailList: (data: SAL1010_R01DetailDto[]) => set((state) => {
		let newList: SAL1010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultSAL1010_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSAL1010_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
						

	isTransported: false,
	setIsTransported: (isTransported: boolean) => set({ isTransported }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		SAL1010_R01Filter: defaultSAL1010_R01Filter,
		SAL1010_R01PastFilter: defaultSAL1010_R01Filter,
		SAL1010_R01List: [],
		selectedSAL1010_R01: undefined,
		SAL1010_R01DetailList: [],
		deletedSAL1010_R01DetailList: [],
		selectedSAL1010_R01DetailList: [],
		editSAL1010_R01: defaultSAL1010_R01HeaderDto,
		allCount: 0,

		isTransported: false,
		detailFetchTrigger: false,
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		detailScrollTop: null,
	})),
})); 